__turbopack_context__.v({
  "heading-2xl": "Heading-module__t6Dh0G__heading-2xl",
  "heading-display": "Heading-module__t6Dh0G__heading-display",
  "heading-lg": "Heading-module__t6Dh0G__heading-lg",
  "heading-md": "Heading-module__t6Dh0G__heading-md",
  "heading-sm": "Heading-module__t6Dh0G__heading-sm",
  "heading-xl": "Heading-module__t6Dh0G__heading-xl",
  "heading-xs": "Heading-module__t6Dh0G__heading-xs",
  "non-responsive": "Heading-module__t6Dh0G__non-responsive",
});
